interface SelectionRequirement {
  readonly minSelections: number
  readonly maxSelections: number
  /** `Infinity` when the group has no total-selection cap. */
  readonly maxTotalSelections: number
  readonly allowsRepeatedSelection: boolean
}

const formatRange = (minimum: number, maximum: number, hasMaximum: boolean): string => {
  if (minimum > 0 && hasMaximum && minimum === maximum) return `Choose ${minimum}`
  if (minimum > 0 && hasMaximum) return `Choose ${minimum}-${maximum}`
  if (hasMaximum) return `Choose up to ${maximum}`
  if (minimum > 0) return `Choose at least ${minimum}`
  return ''
}

/** "Choose …" hint for a customization group; repeated-selection groups are bounded by their total cap. */
export const formatSelectionRequirementLabel = ({
  minSelections,
  maxSelections,
  maxTotalSelections,
  allowsRepeatedSelection
}: SelectionRequirement): string =>
  allowsRepeatedSelection
    ? formatRange(minSelections, maxTotalSelections, Number.isFinite(maxTotalSelections))
    : formatRange(minSelections, maxSelections, maxSelections > 0)
